module.exports = __webpack_public_path__ + "49b15c3f47403d7477af5ee8432e24fe.pdf";